var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#clip0)"},React.createElement("path",{"d":"M11 4.99976L11 16.1698L6.12 11.2898C5.73 10.8998 5.09 10.8998 4.7 11.2898C4.31 11.6798 4.31 12.3098 4.7 12.6998L11.29 19.2898C11.68 19.6798 12.31 19.6798 12.7 19.2898L19.3 12.7098C19.69 12.3198 19.69 11.6898 19.3 11.2998C18.91 10.9098 18.28 10.9098 17.89 11.2998L13 16.1698L13 4.99976C13 4.44976 12.55 3.99976 12 3.99976C11.45 3.99976 11 4.44976 11 4.99976Z","fill":"currentColor"})));
}

ArrowInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
